import ItemHelper from "./services/Item/ItemHelper";
import AgeRestrictedContext from "../Common/AgeRestrictedContext";
import {Reducer} from "redux";
import {getElementTranslation, getElementTranslations} from "../languageUtils";
import {MenusActionTypes, MenuState} from "./types";
import Utils from "../../utils/Utils";

const initialState: MenuState = {
    items: [],
    item_groups: [],
    categories: [],
    modifier_groups: [],
    menus: [],
    promotions: [],
    custom_fields: [],
    availabilities: [],
    initialized: false,
    pending: false,
    error: undefined,
    fetch_status: "NEW"
}


const getCategoryTranslations = (locale: any, categories: any) => {
    return getElementTranslations(locale, categories, ["name", "description"]);
}
const getItemTranslations = (locale: any, items: any) => {
    items.forEach((element: any) => {
        element.selected_items.forEach((si: any) => {
            let item = items.filter((x: any) => x.id == si.item_id)[0];
            if (item) {
                si.translation = getElementTranslation(locale, item, ["name", "description", "content"]);
            }
        })
    });
    return getElementTranslations(locale, items, ["name", "description", "content"]);
}
const getItemGroupTranslations = (locale: any, itemGroups: any) => {
    return getElementTranslations(locale, itemGroups, ["name"]);
}

const getMenuTranslations = (locale: any, menus: any) => {
    return getElementTranslations(locale, menus, ["name"]);
}
const getModifierGroupTranslations = (locale: any, modifierGroups: any) => {
    return getElementTranslations(locale, modifierGroups, ["name"]);
}
const isExistOrderType = (orderTypes: any[], orderType: string) => {
    if (!orderTypes) return true;
    if (orderTypes.length === 0) return true;
    return orderTypes.includes(orderType);
}
const menuReducer: Reducer<MenuState> = (state = initialState, action: any): MenuState => {
    switch (action.type) {
        case MenusActionTypes.PENDING:
            return {
                ...state,
                pending: true,
                fetch_status: "PENDING"
            }
        case MenusActionTypes.ERROR:
            return {
                ...state,
                pending: false,
                error: action.error,
                fetch_status: "ERROR"
            }
        case MenusActionTypes.SUCCESS:
            const data = JSON.parse(JSON.stringify(action.data));
            const dataMenus = JSON.parse(JSON.stringify(data.menus));
            const locale = data.locale;
            const showPriceWithMin = true;

            const parsedDataMenusItems = dataMenus.items.map((item: any) => {
                const copiedItem = JSON.parse(JSON.stringify(item));

                if (copiedItem.price === undefined) {
                    return;
                }

                let fullPrice = copiedItem.price.amount;
                const fullPricesForOrderTypes = {
                    "DELIVERY": copiedItem.price.amount,
                    "PICK_UP": copiedItem.price.amount,
                    "DINE_IN": copiedItem.price.amount,
                    "ROOM_SERVICE": copiedItem.price.amount,
                };
                let minPossiblePrice = 0;
                copiedItem.selected_items = [];
                copiedItem.translation = {
                    name: copiedItem.name,
                    description: copiedItem.description,
                    content: copiedItem.content,
                };

                let isAlcohol = AgeRestrictedContext.isItemAlcohol(copiedItem);
                let isEnergyDrink = AgeRestrictedContext.isItemEnergyDrink(copiedItem);

                copiedItem.modifier_groups.forEach((itemModifierGroup: any) => {
                    let modifierGroup = ItemHelper.getModifierGroup(dataMenus.modifier_groups, itemModifierGroup.modifier_group_id);
                    if (modifierGroup === undefined) {
                        return;
                    }

                    let modifierGroupQuantityInfo = ItemHelper.getModifierGroupQuantityInfo(modifierGroup, copiedItem);
                    let modifierGroupSelectedItems = [] as any[];

                    modifierGroup.options.forEach((modiferGroupOption: any) => {
                        if (modiferGroupOption.type === "ITEM") {
                            let modiferGroupOptionItem = ItemHelper.getItem(dataMenus.items, modiferGroupOption.entity_id);

                            if (modiferGroupOptionItem == undefined) {
                                console.log("Error, item not exist: " + modiferGroupOption.entity_id);
                                return;
                            }

                            if (!isAlcohol && AgeRestrictedContext.isItemAlcohol(modiferGroupOptionItem)) isAlcohol = true;

                            if (!isEnergyDrink && AgeRestrictedContext.isItemEnergyDrink(modiferGroupOptionItem)) isEnergyDrink = true;

                            let itemQuantityInfo = ItemHelper.getItemQuantityInfo(modiferGroupOptionItem, copiedItem, modifierGroup);

                            if (itemQuantityInfo !== undefined && (itemQuantityInfo.default_quantity > 0 || itemQuantityInfo.min_permitted > 0)) {
                                let selectedItemPrice = ItemHelper.getPriceOvveride(modiferGroupOptionItem, copiedItem, modifierGroup);
                                let minQuantityRequired = Utils.zeroIfNull(itemQuantityInfo.default_quantity);
                                if (showPriceWithMin) {
                                    minQuantityRequired = minQuantityRequired > Utils.zeroIfNull(itemQuantityInfo.min_permitted) ? minQuantityRequired : Utils.zeroIfNull(itemQuantityInfo.min_permitted);
                                }
                                if (minQuantityRequired > 0) {
                                    let totalPrice = 0;
                                    let quantityFree = 0;
                                    if (itemQuantityInfo.charge_above > 0) {
                                        let quantityChargeAbove = minQuantityRequired - itemQuantityInfo.charge_above;
                                        if (quantityChargeAbove > 0) {
                                            totalPrice = selectedItemPrice * quantityChargeAbove;
                                            quantityFree = itemQuantityInfo.charge_above;
                                        } else {
                                            quantityFree = minQuantityRequired;
                                        }
                                        fullPrice += totalPrice;
                                        if (isExistOrderType(modiferGroupOptionItem.order_types, "DELIVERY")) fullPricesForOrderTypes.DELIVERY += totalPrice;
                                        if (isExistOrderType(modiferGroupOptionItem.order_types, "ROOM_SERVICE")) fullPricesForOrderTypes.ROOM_SERVICE += totalPrice;
                                        if (isExistOrderType(modiferGroupOptionItem.order_types, "DINE_IN")) fullPricesForOrderTypes.DINE_IN += totalPrice;
                                        if (isExistOrderType(modiferGroupOptionItem.order_types, "PICK_UP")) fullPricesForOrderTypes.PICK_UP += totalPrice;
                                    } else {
                                        if (selectedItemPrice !== undefined) {
                                            totalPrice = minQuantityRequired * selectedItemPrice;
                                            fullPrice += totalPrice;
                                            if (isExistOrderType(modiferGroupOptionItem.order_types, "DELIVERY")) fullPricesForOrderTypes.DELIVERY += totalPrice;
                                            if (isExistOrderType(modiferGroupOptionItem.order_types, "ROOM_SERVICE")) fullPricesForOrderTypes.ROOM_SERVICE += totalPrice;
                                            if (isExistOrderType(modiferGroupOptionItem.order_types, "DINE_IN")) fullPricesForOrderTypes.DINE_IN += totalPrice;
                                            if (isExistOrderType(modiferGroupOptionItem.order_types, "PICK_UP")) fullPricesForOrderTypes.PICK_UP += totalPrice;
                                        }
                                    }

                                    let selectedItem = {
                                        item_id: modiferGroupOptionItem.id,
                                        name: modiferGroupOptionItem.name,
                                        quantity: minQuantityRequired,
                                        total_price: totalPrice,
                                        quantity_free: quantityFree
                                    }
                                    modifierGroupSelectedItems.push(selectedItem);
                                    copiedItem.selected_items.push(selectedItem);
                                }
                            }
                        }
                    });
                    if (modifierGroupQuantityInfo !== undefined && modifierGroupQuantityInfo.charge_above > 0) {
                        let chargeAboveQuantity = modifierGroupQuantityInfo.charge_above;
                        modifierGroupSelectedItems.filter(selectedItem => selectedItem.quantity > selectedItem.quantity_free).sort((a, b) => b.price - a.price).forEach(selectedItem => {
                            if (chargeAboveQuantity <= 0) {
                                return;
                            }
                            let quantityToFreeCharge = selectedItem.quantity - selectedItem.quantity_free;
                            quantityToFreeCharge = quantityToFreeCharge > chargeAboveQuantity ? chargeAboveQuantity : quantityToFreeCharge;
                            selectedItem.quantity_free += quantityToFreeCharge;
                            let priceForOne = selectedItem.total_price / selectedItem.quantity;
                            let minusPrice = priceForOne * quantityToFreeCharge;
                            selectedItem.total_price = selectedItem.total_price - minusPrice;
                            chargeAboveQuantity = chargeAboveQuantity - quantityToFreeCharge;
                            fullPrice -= minusPrice;


                            fullPricesForOrderTypes.DELIVERY -= minusPrice;
                            fullPricesForOrderTypes.ROOM_SERVICE -= minusPrice;
                            fullPricesForOrderTypes.DINE_IN -= minusPrice;
                            fullPricesForOrderTypes.PICK_UP -= minusPrice;
                        });
                    }
                    if (showPriceWithMin && modifierGroupQuantityInfo !== undefined && modifierGroupQuantityInfo.min_permitted > 0) {
                        let selectedQuantity = modifierGroupSelectedItems.reduce((a, b) => a + b.quantity, 0);
                        let quantityForAddPrice = modifierGroupQuantityInfo.min_permitted - selectedQuantity;
                        if (modifierGroupQuantityInfo.charge_above > 0) {
                            quantityForAddPrice = modifierGroupQuantityInfo.charge_above > quantityForAddPrice ? 0 : quantityForAddPrice - modifierGroupQuantityInfo.charge_above;
                        }
                        if (quantityForAddPrice > 0) {
                            let addMinPossiblePrice = undefined as any;
                            modifierGroup.options.forEach((mdo: any) => {
                                let modiferGroupOptionItem = ItemHelper.getItem(dataMenus.items, mdo.entity_id);
                                let selectedItemPrice = ItemHelper.getPriceOvveride(modiferGroupOptionItem, item, modifierGroup);
                                if (!selectedItemPrice) selectedItemPrice = 0;

                                if (addMinPossiblePrice === undefined || addMinPossiblePrice > selectedItemPrice) {
                                    addMinPossiblePrice = selectedItemPrice;
                                }
                                if (selectedItemPrice <= 0) return;
                            })

                            if (addMinPossiblePrice !== undefined && addMinPossiblePrice > 0) {
                                minPossiblePrice += addMinPossiblePrice * quantityForAddPrice;
                            }
                        }
                    }
                });
                copiedItem.order_types_full_price = fullPricesForOrderTypes;
                copiedItem.order_types_min_price = {
                    DELIVERY: fullPricesForOrderTypes.DELIVERY + minPossiblePrice,
                    ROOM_SERVICE: fullPricesForOrderTypes.ROOM_SERVICE + minPossiblePrice,
                    PICK_UP: fullPricesForOrderTypes.PICK_UP + minPossiblePrice,
                    DINE_IN: fullPricesForOrderTypes.DINE_IN + minPossiblePrice,
                };
                minPossiblePrice += fullPrice;
                copiedItem.full_price = fullPrice;
                copiedItem.min_possible_price = minPossiblePrice;
                copiedItem.alcohol = isAlcohol;
                copiedItem.energy_drink = isEnergyDrink;

                return copiedItem;
            });

            const items = getItemTranslations(locale, parsedDataMenusItems);
            const categories = getCategoryTranslations(locale, dataMenus.categories);
            const menus = getMenuTranslations(locale, dataMenus.menus);
            const modifierGroups = getModifierGroupTranslations(locale, dataMenus.modifier_groups);
            const itemGroups = getItemGroupTranslations(locale, dataMenus.item_groups);
            const isAlcohol = items.some((x: any) => AgeRestrictedContext.isItemAlcohol(x));

            if (isAlcohol) {
                AgeRestrictedContext.setAlcohol(true);
            }

            return {
                ...state,
                items: items,
                item_groups: itemGroups,
                categories: categories,
                modifier_groups: modifierGroups,
                availabilities: [...dataMenus.availabilities],
                custom_fields: [...dataMenus.custom_fields],
                promotions: [...dataMenus.promotions],
                menus: [...menus],
                fetch_status: "SUCCESS",
                pending: false,
                initialized: true,
            }
        case MenusActionTypes.CLEAN:
            return {
                ...initialState
            }
        default:
            return state;
    }
}

export default menuReducer;
export const getItems = (state: any) => state.items;
export const getCategories = (state: any) => state.categories;
export const getItemGroups = (state: any) => state.item_groups;
export const getModifierGroups = (state: any) => state.modifier_groups;
export const getAvailabilities = (state: any) => state.availabilities;
export const getCustomFields = (state: any) => state.custom_fields;
export const getMenus = (state: any) => state.menus;
export const getMenuState = (state: any) => state;
export const getPromotions = (state: any) => state.promotions;